module.exports = __webpack_public_path__ + "static/media/PIJL_07.8077b1f5.png";